import { Status } from './Note';

const borderColor = {
  error: 'red.80',
  info: 'separator.primary',
  success: 'green.80',
  warning: 'yellow.80',
};

const decorationBackground = {
  error: 'red.95',
  info: 'neutral.95',
  success: 'green.95',
  warning: 'yellow.95',
};

const decorationColor = {
  error: 'red.50',
  info: 'neutral.40',
  success: 'green.50',
  warning: 'yellow.50',
};
const NoteTheme = {
  baseStyle({ isExpanded, status }: { isExpanded: boolean; status: Status }) {
    return {
      buttonContainer: {
        background: isExpanded ? undefined : 'linear-gradient(0deg, #FFF 12.57%, rgba(255, 255, 255, 0.00) 100%)',
        borderBottomRadius: '8',
        bottom: 1,
        left: isExpanded ? 'auto' : '40px',
        paddingBottom: '16',
        paddingTop: '80',
        paddingX: '24',
        position: 'absolute',
        right: 1,
        svg: {
          transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
          transition: '300ms',
        },
        textAlign: 'right',
      },
      container: {
        borderBottomRightRadius: '8',
        borderColor: borderColor[status],
        borderLeft: 'none',
        borderTopRightRadius: '8',
        borderWidth: '1px',
        flexGrow: 1,
        overflow: 'hidden',
        paddingBottom: ['80', '32'],
        paddingLeft: '16',
        paddingRight: '24',
        paddingTop: '24',
      },
      decoration: {
        bg: decorationBackground[status],
        borderBottomLeftRadius: '8',
        borderColor: borderColor[status],
        borderRight: 'none',
        borderTopLeftRadius: '8',
        borderWidth: '1px',
        color: decorationColor[status],
        display: 'flex',
        px: '8',
        py: '12',
        width: '40',
      },
      wrapper: {
        borderRadius: '8',
        boxShadow: 'medium',
        display: 'flex',
        position: 'relative',
      },
    };
  },
  parts: ['container', 'icon', 'body', 'buttonContainer'],
};

export default NoteTheme;
